import { AmenitiesResponse } from "@/types/amenity";

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://www.lilylanka.com";

export const amenityService = {
  // Fetch amenities for a booking/hotel room
  async getAmenities(bookingId?: number | string): Promise<AmenitiesResponse> {
    try {
      const url = bookingId
        ? `${API_BASE_URL}/api/CustomerBookings/${bookingId}`
        : `${API_BASE_URL}/api/Amenities`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data: AmenitiesResponse = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching amenities:", error);
      return {
        result: [],
        message: "Error fetching amenities",
        errors: [error instanceof Error ? error.message : "Unknown error"],
        id: 0,
      };
    }
  },

  // Get amenities for a specific room type
  async getRoomTypeAmenities(roomTypeId: number): Promise<AmenitiesResponse> {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/RoomTypes/${roomTypeId}/amenities`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      // Handle 404 gracefully - room type amenities might not exist
      if (response.status === 404) {
        console.warn(
          `Room type amenities not found for roomTypeId: ${roomTypeId}`,
        );
        return {
          result: [],
          message: "No amenities available for this room type",
          errors: [],
          id: 0,
        };
      }

      if (!response.ok) {
        console.error(`API error ${response.status} fetching room amenities`);
        return {
          result: [],
          message: "Error fetching amenities",
          errors: [`API error: ${response.status}`],
          id: 0,
        };
      }

      const data: AmenitiesResponse = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching room amenities:", error);
      return {
        result: [],
        message: "Error fetching amenities",
        errors: [error instanceof Error ? error.message : "Unknown error"],
        id: 0,
      };
    }
  },
};
